// extracted by mini-css-extract-plugin
module.exports = {"content-section":"ContentSection_content-section__sdd3s","title":"ContentSection_title__crpDh"};